export class ScopeResolver 
{ 
  static _combineScopes( scope:string, childScope:string ) 
  {
      childScope = childScope.replace(/&&/, "&>");
      
      if (/&\w/.test(childScope) && /\w$/.test(scope)) 
      {
          childScope = childScope.replace(/&/, "& ");
      }

      if (/\w&/.test(childScope) && /^\w/.test(scope)) 
      {
          scope = " " + scope;
      }

      return childScope.replace(/&/, scope);
  }

  static inheritScopes( parentScope:string, childScope:string ) 
  {
    let parentScopes = parentScope.split(",");
    let childScopes = childScope.split(",");
    let combinedScope = "";

    for (let i = 0; i < parentScopes.length; i++) 
    {
      for (let j = 0; j < childScopes.length; j++) 
      {
        if (!(i === 0 && j === 0)) {
            combinedScope += ", ";
        }
        var combinedChildScope = ScopeResolver._combineScopes(parentScopes[i], childScopes[j]);
        combinedScope += combinedChildScope;
      }
    }
    
    return combinedScope;
  }
}